import { render } from "./Quiz.vue?vue&type=template&id=54ea02a0&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=54ea02a0&scoped=true&lang=css"

import exportComponent from "/home/debian/quiz-anatomie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ea02a0"]])

export default __exports__